import { useEffect, useState } from "react";
import { Download, Share, Plus } from "lucide-react";

// "Install app" button on the login page. Uses the native beforeinstallprompt on
// Android/desktop Chrome; falls back to an iOS "Add to Home Screen" hint.
export function InstallPWA() {
  const [deferred, setDeferred] = useState(null);
  const [installed, setInstalled] = useState(false);
  const [showIos, setShowIos] = useState(false);

  const isStandalone = typeof window !== "undefined" &&
    (window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone);
  const isIos = typeof navigator !== "undefined" && /iphone|ipad|ipod/i.test(navigator.userAgent);

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setDeferred(e); };
    const onInstalled = () => setInstalled(true);
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (isStandalone || installed) return null;

  async function install() {
    if (deferred) {
      deferred.prompt();
      try { await deferred.userChoice; } catch (e) { /* ignore */ }
      setDeferred(null);
    } else if (isIos) {
      setShowIos((v) => !v);
    }
  }

  // Only show when installable (Android/desktop) or on iOS (manual instructions).
  if (!deferred && !isIos) return null;

  return (
    <div className="mt-6" data-testid="install-pwa">
      <button onClick={install} type="button"
        className="w-full flex items-center justify-center gap-2 rounded-lg border border-[#C84B31] text-[#C84B31] py-2.5 text-sm font-semibold hover:bg-[#C84B31] hover:text-white transition-colors"
        data-testid="install-pwa-btn">
        <Download className="w-4 h-4" /> Install ITO app on this device
      </button>
      {showIos && (
        <div className="mt-2 text-xs text-[#68665E] bg-[#F5F4F0] border border-[#E5E3DB] rounded-lg p-3 leading-relaxed" data-testid="install-pwa-ios">
          On iPhone/iPad: tap <Share className="inline w-3.5 h-3.5 -mt-0.5" /> <strong>Share</strong>, then
          <strong> Add to Home Screen</strong> <Plus className="inline w-3.5 h-3.5 -mt-0.5" />. Open ITO from your
          home screen and enable notifications from the bell.
        </div>
      )}
    </div>
  );
}

export default InstallPWA;
